var noop = function () { };
var rethrow = function (error) {
    throw error;
};
export function toObserver(observer) {
    var _a, _b, _c;
    if (observer) {
        if (observer.next && observer.error && observer.complete) {
            return observer;
        }
        return {
            complete: ((_a = observer.complete) !== null && _a !== void 0 ? _a : noop).bind(observer),
            error: ((_b = observer.error) !== null && _b !== void 0 ? _b : rethrow).bind(observer),
            next: ((_c = observer.next) !== null && _c !== void 0 ? _c : noop).bind(observer),
        };
    }
    return {
        complete: noop,
        error: rethrow,
        next: noop,
    };
}
//# sourceMappingURL=to-observer.js.map
